import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";

export default function Hero() {
  const handleGetStarted = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      className="relative min-h-screen flex items-center justify-center overflow-hidden animated-gradient"
      data-testid="section-hero"
    >
      {/* Animated Gradient Background - handled by CSS utility */}
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-32 md:py-40 text-center">
        {/* Main Headline with Gradient Text */}
        <h1
          className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold gradient-text mb-6 tracking-tight leading-tight"
          data-testid="text-hero-title"
        >
          Happy Home Solution.
          <br />
          Big or Small — We Fix It All.
        </h1>
        
        <p className="text-lg md:text-xl text-gray-400 mb-12 max-w-2xl mx-auto">
          Free in-home measurement & consultation. Licensed, insured, and code-compliant. Serving the Greater Houston Area.
        </p>

        {/* Large Phone Number with Glow */}
        <a 
          href="tel:8329989595"
          className="inline-flex items-center gap-4 mb-16 group"
          data-testid="link-hero-phone"
        >
          <div className="glass-surface p-4 rounded-full group-hover:glow-cyan transition-all duration-300">
            <Phone className="h-8 w-8 md:h-10 md:w-10 text-[#00d9ff]" data-testid="icon-hero-phone" />
          </div>
          <span 
            className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-heading font-extrabold gradient-text-primary tracking-tight hover:scale-105 transition-transform duration-300"
            data-testid="text-hero-phone"
          >
            (832) 998-9595
          </span>
        </a>

        {/* CTA Buttons with Glassmorphism */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-8">
          <Button
            size="lg"
            className="text-lg px-10 py-7 h-auto font-semibold glass-surface hover:glow-cyan hover-lift transition-all duration-300 border border-[#00d9ff]/30"
            onClick={handleGetStarted}
            data-testid="button-hero-get-started"
          >
            <span className="text-[#00d9ff]">Get Free Estimate</span>
            <ArrowRight className="ml-2 h-5 w-5 text-[#00d9ff]" />
          </Button>
          
          <Button
            size="lg"
            variant="outline"
            className="text-lg px-10 py-7 h-auto font-semibold glass-surface border-[#ffd700]/40 text-[#ffd700] hover:glow-gold hover-lift transition-all duration-300"
            onClick={() => {
              const element = document.getElementById("portfolio");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}
            data-testid="button-hero-view-portfolio"
          >
            View Our Work
          </Button>
        </div>

        {/* Trust Indicators */}
        <p className="text-base md:text-lg text-gray-400/90" data-testid="text-hero-stats">
          Over <span className="text-[#00d9ff]">18 years of experience</span> · <span className="text-[#00d9ff]">150+ completed projects</span> · Average rating <span className="text-[#ffd700]">4.8/5</span>
        </p>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-[#00d9ff]/50 rounded-full flex items-start justify-center p-2 glow-cyan">
            <div className="w-1 h-3 bg-[#00d9ff]/70 rounded-full" />
          </div>
        </div>
      </div>
    </section>
  );
}
